import { render, staticRenderFns } from "./VInputTag.vue?vue&type=template&id=e7e6c8e6&functional=true"
var script = {}
import style0 from "./VInputTag.vue?vue&type=style&index=0&id=e7e6c8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports